import React from 'react';
import { message, Button, Card } from 'antd';
import { useHistory } from 'react-router-dom';

import { LayoutPage } from 'components/layouts';
import { useAuthState } from 'react-firebase-hooks/auth';
import Client from 'containers/app/client';

import './style.css';

const DebugW = () => {
  const history = useHistory();
  const [user, loading, error] = useAuthState(Client.auth);
  if (loading) return 'loading...';
  if (error) throw error;

  const {
    auth: { currentUser },
  } = Client;

  return (
    <LayoutPage className="debug-page">
      <LayoutPage.Container className="wrapper">
        <h1>Debug</h1>
        <Card title={user.uid}>
          <Button
            onClick={async () => {
              await currentUser.getIdTokenResult(true);
              message.success('Token refreshed');
            }}
          >
            Re-fetch role
          </Button>
          <Button
            onClick={async () => {
              const addUserRole = Client.functions.httpsCallable(
                'UserRoles-setRole'
              );
              const res = await addUserRole({
                uid: Client.currentUserId(),
                email: user.email,
                role: 'isWorker',
              });
              message.success(res.data.message);
            }}
          >
            Force set role to worker
          </Button>
          <Button
            onClick={async () => {
              const addUserRole = Client.functions.httpsCallable(
                'UserRoles-setRole'
              );
              const res = await addUserRole({
                uid: Client.currentUserId(),
                email: user.email,
                role: 'isEmployer',
              });
              message.success(res.data.message);
            }}
          >
            Force set role to employer
          </Button>
          <Button
            onClick={() => {
              Client.sendEmailVerification();
            }}
          >
            Send verification email
          </Button>
          <Button
            onClick={() => {
              history.push('/update-profile');
            }}
          >
            Update Profile
          </Button>
          <Button
            onClick={async () => {
              const setAdmin = Client.functions.httpsCallable(
                'UserRoles-setAdmin'
              );
              const res = await setAdmin({
                uid: Client.currentUserId(),
                email: user.email,
              });
              message.success(res.data.message);
            }}
          >
            Set as admin
          </Button>
        </Card>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

DebugW.propTypes = {};

export default DebugW;
